{"USE_ANSIBLE_VARS":"true","BUILD_CONFIG":"production","VERSION":"bcccd8f1a7c657c9b4a55c88544b618f8a410124"}